import React from 'react';
import { Box, Snackbar, Alert, Modal } from '@mui/material';
import { SubscriptionAdd } from '../../../../pages/student/billing/subscription/components/overview/add.js';
import { getProducts } from '../../../../services/studentBillingService';
import { TermsAndConditions } from '../../../../pages/student/billing/subscription/components/overview/terms.js';
import { loadStripe } from '@stripe/stripe-js';
import { stripePublicKey } from '../../../../constants/globals';
import { Elements } from '@stripe/react-stripe-js';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 400,
    minWidth: 300,
    maxHeight: 400,
    overflowY: 'scroll',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4
};

const stripePromise = loadStripe(stripePublicKey);

export const StudentsSubscribe = ({user}) => {
    const [product, setProduct] = React.useState({});
    const [stripeOptions, setStripeOptions] = React.useState({});
    const [error, setError] = React.useState(false);
    const [errorText, setErrorText] = React.useState('');
    const handleCloseError = () => setError(false);
    const [openTermsModal, setOpenTermsModal] = React.useState(false);
    const handleCloseTermsModal = () => setOpenTermsModal(false);
  
    React.useEffect(() => {
        getProducts(localStorage.getItem('token')).then(subscriptionData => {
            if (subscriptionData.status == true) {
              setProduct(subscriptionData.data[0]);
              setStripeOptions({
                  mode: 'subscription',
                  currency: 'usd',
                  amount: subscriptionData.data[0]?.pricing[0]?.unit_amount,
                  captureMethod: 'automatic',
                  setupFutureUsage: 'off_session'
              });
            } else {
                setError(true);
                setErrorText(subscriptionData.message);
            }
        }).catch(err => {
            setError(true);
            setErrorText(err);
        });
    }, []);

    return (
        <React.Fragment>
            {Object.keys(stripeOptions).length !== 0 && user?.stripe_subscription_id === null && (
                <Elements stripe={stripePromise} options={stripeOptions}>
                    <SubscriptionAdd 
                        product={product} 
                        noExtraText={true}
                        setOpenTermsModal={setOpenTermsModal} 
                        setError={setError} 
                        setErrorText={setErrorText} 
                    />
                </Elements>
            )}
            <Snackbar
                open={error}
                onClose={handleCloseError}
                autoHideDuration={6000}
            >
                <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%', maxWidth: '500px' }}>
                {errorText}
                </Alert>
            </Snackbar>
            <Modal
                open={openTermsModal}
                onClose={handleCloseTermsModal}
            >
                <Box sx={style}>
                    <TermsAndConditions />
                </Box>
            </Modal>
        </React.Fragment>
    );
};